export default __webpack_public_path__ + "static/media/logo-light.1da95d96.svg";